<template>
  <div>
    <multiselect
      v-model="selected"
      @input="onChange"
      :options="options"
      :custom-label="labelSite"
      :multiple="isMulti"
      :taggable="isTagabble"
      selectLabel=""
      selectedLabel="«"
      deselectLabel=""
      :label="$t('Nome')"
      :allowEmpty="true"
      :preselectFirst="true"
      :loading="isLoading"
      track-by="id"
      :disabled="isDisabled || isLoading"
      placeholder=""
      class="multiselect-primary"
      inputContainerClass="d-flex"
      :hide-selected="true"
    >
      <template slot="tag" slot-scope="{ option, remove }" class="d-flex" v-if="option.length > 0">
        <span class="multiselect__tag">
          <span>{{ option.nome_fantasia }}</span>
          <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
        </span>
      </template>
      <template slot="noOptions">
        <span>{{ $t('Nenhum dado foi retornado') }}.</span>
      </template>
      <template slot="placeholder">
        <span>{{ $t(emptyLabel) }}</span>
      </template>
    </multiselect>
    <b-button v-if="showSelectAll" @click="selectAllItems" class="btn btn-sm btn-primary mt-2">
      {{ $t('Selecionar Todos') }}
    </b-button>
    <b-button v-if="showRemoveAll" @click="removeAllItems" class="btn btn-sm btn-secondary mt-2 ml-2">
      {{ $t('Remover Todos') }}
    </b-button>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'sitesSelected',
    'empresas',
    'selectAll',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'verifyCompany',
    'verifyConfigSms',
    'isTagabble',
    'isObject',
    'AditionalColumns',
    'customFilterSysa',
    'validPermissoesNegocio',
    'idLocalidade'
  ],

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e == null) {
        this.$emit('selectChange', 'id_localidade_web', null);
        return;
      }
      if (this.isMulti) {
        let arr = new Array();
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_localidade_web', arr);
      } else {
        this.isObject
          ? this.$emit('selectChange', 'id_localidade_web', e)
          : this.$emit('selectChange', 'id_localidade_web', e.id);
      }
    },
    labelSite({ nome_fantasia }) {
      return `${nome_fantasia}`;
    },
    setValue(value) {
      if (value) {
        if (this.isMulti) {
          this.selected = [];
          value.forEach((el) => {
            const option = this.options.find((option) => option.id === el);
            if (option) {
              this.selected.push(option);
            }
          });
        } else {
          this.selected = this.options.find((option) => option.id === parseInt(value));
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },

    setOptions(params) {
      const sites = this.$store.state.user.info.hasOwnProperty('sites') ? this.$store.state.user.info.sites : null;
      const idEmpresa = this.$store.state.user.info.id_empresa;
      const gestorIsRoot = this.$store.state.user.info.root;
      let filter = `${idEmpresa} = any(select (json_array_elements(id_empresas)::text)::integer)`;

      if (this.validPermissoesNegocio) {
        let permissoes_negocio = this.$util.getIdsPermissoesNegocios();

        if (gestorIsRoot && params?.empresas && params?.empresas.length > 0) {
          permissoes_negocio = params.empresas;
        } else if (!gestorIsRoot && params?.empresas && params?.empresas.length > 0) {
          const permissoes = this.$util.getObjectRaw(permissoes_negocio);
          permissoes_negocio = params.empresas.filter((empresa) => permissoes.includes(empresa));
        }
        const idEmpresasPermissaoNegocio =
          permissoes_negocio && permissoes_negocio.length > 0
            ? `(${permissoes_negocio.toString()})`
            : `(${idEmpresa})`;

        filter = `id_empresa IN ${idEmpresasPermissaoNegocio}`;
      }

      if (this.verifyCompany) {
        filter = `business_logic.localidade_web.id_empresa=${idEmpresa}`;
      }

      if (this.verifyConfigSms) {
        filter = `business_logic.localidade_web.configuracao->>'notification' is not null AND business_logic.localidade_web.configuracao->>'smsInfo' is not null`;
      }

      if (sites != null && sites != '[]' && sites != ' ' && sites != '') {
        filter += ` and business_logic.localidade_web.id in (${sites})`;
      }

      if (this.idLocalidade) {
        filter += ` and business_logic.localidade_web.id_localidade=${this.idLocalidade}`;
      }

      if (this.customFilterSysa === true) {
        if (this.$store?.state?.user?.configEmpresa?.idsSiteAfiliado?.length) {
          filter += ` and business_logic.localidade_web.id in (${this.$store.state.user.configEmpresa.idsSiteAfiliado.toString()}) `;
        } else {
          this.options = [];
          return;
        }
      }

      this.isLoading = true;
      this.$atenaList
        .getSites({
          columns: `id, nome_fantasia${this.AditionalColumns ? ',' + this.AditionalColumns : ''}`,
          filter: filter,
          order: 'id'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome_fantasia: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          if (params?.sitesSelected && params?.sitesSelected.length > 0) {
            const sitesSelected = params.sitesSelected.map((site) => ({
              id: site.id,
              nome_fantasia: site.nome_fantasia
            }));
            this.options = [...new Set([...this.options, ...sitesSelected].map(JSON.stringify))]
              .map(JSON.parse)
              .sort((a, b) => a.id - b.id);
          }
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: `${err.code} - ${err.message}`,
            msgTranslate: false,
            type: 'error'
          });
        });
    },
    selectAllItems() {
      if (this.isMulti) {
        this.selected = [...this.options];
        this.onChange(this.selected);
      }
    },
    removeAllItems() {
      if (this.isMulti) {
        this.selected = [];
        this.onChange(this.selected);
      }
    }
  },

  watch: {
    nameField: function (value) {
      this.setValue(value);
    },
    sitesSelected: function (value) {
      this.setOptions({ sitesSelected: value });
    },
    empresas: function (value) {
      this.setOptions({ empresas: value });
    },
    idLocalidade() {
      this.setOptions();
    }
  },

  computed: {
    showRemoveAll() {
      return this.isMulti && !this.isDisabled && this.selectAll && this.selected?.length;
    },
    showSelectAll() {
      return this.isMulti && !this.isDisabled && this.selectAll;
    }
  },

  created() {
    this.setOptions();
    if (this.empresas) {
      this.setOptions({ empresas: this.empresas });
    }
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
